import React from "react";
import { Link } from "react-router-dom";
import { ESTUDIO } from "../../data/estudio";
import { FOOTER_SEGMENTOS, FOOTER_SITIO } from "../../data/nav";
import { WHATSAPP_NUMBER } from "../../utils/whatsapp";
/* Fondo papel: va el logotipo de marca a dos tonos, el mismo que el header
   con scroll. En el pie el nombre estaba escrito en Archivo, lo que dejaba
   el sitio sin la marca en ninguna parte por debajo del pliegue. */
import logoColor from "../../assets/logo-omega-color.png";

const YEAR = new Date().getFullYear();

const SiteFooter = () => (
  <footer className="border-t border-navy-100 bg-sand-50">
    <div className="container-omega py-16 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-4">
          <Link to="/" aria-label="Omega Digital, ir al inicio" className="inline-block">
            <img
              src={logoColor}
              alt="Omega Digital"
              width="186"
              height="46"
              className="h-11 w-auto"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p className="mt-5 max-w-xs text-[0.9375rem] leading-relaxed text-navy-600">
            Fotografía de eventos y fotos en estudio en Santiago. Precio publicado. Factura.
          </p>
          <p className="mt-8 text-sm text-navy-500">
            Sedes: {ESTUDIO.sedes.join(" · ")}
          </p>
          <p className="mt-1 text-sm text-navy-500">{ESTUDIO.ciudad}, {ESTUDIO.pais}</p>
        </div>

        <nav className="lg:col-span-3" aria-label="Fotografía">
          <p className="text-sm font-semibold text-navy-900">Servicios</p>
          <ul className="mt-5 space-y-3">
            {FOOTER_SEGMENTOS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-sm text-navy-600 transition-colors hover:text-navy-900">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="lg:col-span-2" aria-label="Sitio">
          <p className="text-sm font-semibold text-navy-900">Sitio</p>
          <ul className="mt-5 space-y-3">
            {FOOTER_SITIO.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-sm text-navy-600 transition-colors hover:text-navy-900">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="lg:col-span-3">
          <p className="text-sm font-semibold text-navy-900">Contacto</p>
          <ul className="mt-5 space-y-3 text-sm text-navy-600">
            <li>
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-navy-900"
              >
                WhatsApp
              </a>
            </li>
            <li>
              <a href={`tel:+${ESTUDIO.whatsapp}`} className="hover:text-navy-900">
                {ESTUDIO.telefonoDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${ESTUDIO.email}`} className="hover:text-navy-900">
                {ESTUDIO.email}
              </a>
            </li>
            <li>
              <a href={ESTUDIO.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-navy-900">
                Instagram
              </a>
            </li>
            <li>
              <a href={ESTUDIO.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-navy-900">
                Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-navy-100 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-navy-500">© {YEAR} {ESTUDIO.nombre}. Todos los derechos reservados.</p>
        <p className="text-xs text-navy-500">Fotografía profesional · {ESTUDIO.ciudad}</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
